import { useState } from 'react';
import { useUserState } from '../../hooks/context/useUserState';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { requestDashboards } from '../requests/dashboards/requestDashboards';
import { SET_DASHBOARDS } from '../../constants';

export const useGetDashboards = () => {
  const {
    state: { token, dashboards },
    dispatch,
  } = useUserState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const handleApiError = useApiErrorHandling();

  const fetch = async (forceHeader?: string) => {
    setIsLoading(true);
    try {
      const res = await requestDashboards(token, forceHeader);
      if (res.dashboards) {
        const newDashboards = res.dashboards.map((dashboard) => {
          const foundDashboard = dashboards.find((d) => d.id === dashboard.id);
          if (foundDashboard) {
            return {
              ...foundDashboard,
              ...dashboard,
            };
          }
          return dashboard;
        });
        dispatch({
          type: SET_DASHBOARDS,
          payload: newDashboards,
        });
        return newDashboards;
      }
      return undefined;
    } catch (e) {
      if (e instanceof Error) setError(e);
      handleApiError(e, false, (forceHeader) => fetch(forceHeader));
      return undefined;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    fetch,
  };
};
